/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Skeleton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { formatBRL } from './constants';

const Field = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: 'uppercase', letterSpacing: 0.4, fontWeight: 600, fontSize: '0.65rem' }}
    >
      {label}
    </Typography>
    <Typography variant="body2" sx={{ fontWeight: 500, mt: 0.25 }}>
      {value ?? '—'}
    </Typography>
  </Box>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const UsuarioSummarySkeleton = () => (
  <Card variant="outlined" sx={{ borderRadius: 2 }}>
    <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
      <Skeleton width={180} height={32} />
      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        {[1, 2, 3, 4].map((key) => (
          <Grid key={key} size={{ xs: 6, sm: 3 }}>
            <Skeleton width="80%" height={14} />
            <Skeleton width="60%" height={20} sx={{ mt: 0.5 }} />
          </Grid>
        ))}
      </Grid>
    </CardContent>
  </Card>
);

const UsuarioSummary = ({ usuario, kpis, loading, visible, onClose }) => {
  if (!visible) return null;
  if (loading) return <UsuarioSummarySkeleton />;
  if (!usuario) return null;

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ py: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <PersonOutlinedIcon color="primary" fontSize="small" />
          <Typography variant="h5" component="span" sx={{ fontWeight: 700 }}>
            {usuario.nome || '—'}
          </Typography>
          {usuario.email && (
            <Typography variant="body2" color="text.secondary" component="span" sx={{ flex: 1 }}>
              {usuario.email}
            </Typography>
          )}
          {onClose && (
            <Tooltip title="Ver todos os colaboradores">
              <IconButton size="small" onClick={onClose} aria-label="Fechar colaborador">
                <CloseOutlinedIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 6, sm: 3 }}>
            <Field label="Total no período" value={formatBRL(kpis?.totalGasto)} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <Field label="Via Aporte" value={formatBRL(kpis?.viaAporte)} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <Field label="Via Cartão" value={formatBRL(kpis?.viaCartao)} />
          </Grid>
          <Grid size={{ xs: 6, sm: 3 }}>
            <Field label="Notas" value={kpis?.quantidadeNotas ?? 0} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

UsuarioSummary.propTypes = {
  usuario: PropTypes.shape({
    id: PropTypes.string,
    nome: PropTypes.string,
    email: PropTypes.string,
  }),
  kpis: PropTypes.object,
  loading: PropTypes.bool,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

UsuarioSummary.defaultProps = {
  usuario: null,
  kpis: null,
  loading: false,
  visible: false,
  onClose: null,
};

export default UsuarioSummary;
